
function uvGetColor(type) {

  var colors =  {
    building: 'white',
    building_fill: '#009ee3',
    building_fill_done: '#78AB46',
    building_fill_reserved: '#ffed00',

    building_highlight: '#666',
    building_highlight_selected: '#E5007D',
    building_highlight_selected_fill: '#E5007D',

    building_analyze: '#FFF',
    building_analyze_fill_highest: '#2c7bb6',
    building_analyze_fill_high: '#abd9e9',
    building_analyze_fill_low: '#fdae61',
    building_analyze_fill_lowest: '#d7191c',
    building_analyze_fill_undefined: 'transparent',

    priority_area: '#FFF',
    priority_area_fill_highest: '#2c7bb6',
    priority_area_fill_high: '#abd9e9',
    priority_area_fill_low: '#fdae61',
    priority_area_fill_lowest: '#d7191c',
    priority_area_fill_undefined: 'transparent',
  };

  return colors[type];
}

window.uvGetColor = uvGetColor;
